"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GALLERY_ITEM_TYPE = void 0;
Object.defineProperty(exports, "GALLERY_MAX_THUMBNAIL_COUNT", {
  enumerable: true,
  get: function () {
    return _GalleryContainer.GALLERY_MAX_THUMBNAIL_COUNT;
  }
});
exports.Gallery = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Modal = require("b2b-components/theme/components/Modal");
var _device = require("b2b-components/utils/device");
var _GalleryContainer = require("../GalleryContainer");
var _Body = require("./Body");
var _Image360Item = require("./Body/ItemList/Image360Item");
var _ImageItem = require("./Body/ItemList/ImageItem");
var _VideoItem = require("./Body/ItemList/VideoItem");
var _MobileBody = require("./MobileBody");
var _PreviewBody = require("./PreviewBody");
require("b2b-components/core/assets/vendor/magic360/magic360.css");
require("b2b-components/core/assets/vendor/magiczoom/magiczoom.css");
require("./Gallery.scss");
let GALLERY_ITEM_TYPE = exports.GALLERY_ITEM_TYPE = /*#__PURE__*/function (GALLERY_ITEM_TYPE) {
  GALLERY_ITEM_TYPE["fallback"] = "fallback";
  GALLERY_ITEM_TYPE["image360"] = "image360";
  GALLERY_ITEM_TYPE["image"] = "image";
  GALLERY_ITEM_TYPE["more"] = "more";
  GALLERY_ITEM_TYPE["video"] = "video";
  return GALLERY_ITEM_TYPE;
}({});
const Gallery = _ref => {
  let {
    currentItemIndex,
    currentPreviewItemIndex,
    onItemChange,
    onPreviewItemChange,
    onPreviewItemClick,
    isModalOpened,
    onModalClose,
    onModalKeyDown,
    deviceType,
    image360 = null,
    images = null,
    manufacturerLink = null,
    manufacturerLogoUrl = null,
    maxThumbnailCount = _GalleryContainer.GALLERY_MAX_THUMBNAIL_COUNT,
    text = {
      menuMobileImageLink: '',
      menuMobileVideoLink: '',
      spinHint: '',
      spinHintMobile: '',
      zoomHint: '',
      zoomHintMobile: ''
    },
    ...restProps
  } = _ref;
  const commonProps = {
    ...restProps,
    deviceType,
    image360,
    images,
    manufacturerLink,
    manufacturerLogoUrl,
    maxThumbnailCount,
    text
  };
  const renderModalBody = () => {
    if ((0, _device.isMobile)(deviceType)) {
      return /*#__PURE__*/_react.default.createElement(_MobileBody.MobileBody, (0, _extends2.default)({}, commonProps, {
        currentItemIndex: currentItemIndex,
        onItemChange: onItemChange
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_Body.Body, (0, _extends2.default)({}, commonProps, {
      Image360ItemComponent: _Image360Item.Image360Item,
      ImageItemComponent: _ImageItem.ImageItem,
      VideoItemComponent: _VideoItem.VideoItem,
      currentItemIndex: currentItemIndex,
      onItemChange: onItemChange
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Gallery"
  }, /*#__PURE__*/_react.default.createElement(_PreviewBody.PreviewBody, (0, _extends2.default)({}, commonProps, {
    currentItemIndex: currentPreviewItemIndex || 0,
    onItemChange: onPreviewItemChange,
    onItemClick: onPreviewItemClick
  })), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    className: "cds-Gallery-Modal",
    content: renderModalBody,
    isOpen: isModalOpened,
    onCloseModal: onModalClose,
    onKeyDown: onModalKeyDown,
    type: _Modal.MODAL_TYPE.fullscreen
  }));
};
exports.Gallery = Gallery;
//# sourceMappingURL=Gallery.js.map